import { render, staticRenderFns } from "./PrintTransferTable.vue?vue&type=template&id=b1af9f74&"
import script from "./PrintTransferTable.vue?vue&type=script&lang=js&"
export * from "./PrintTransferTable.vue?vue&type=script&lang=js&"
import style0 from "./PrintTransferTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports